export default __webpack_public_path__ + "static/media/e23fc372ff905f76082d2f291f161c72.svg";